import { authActions } from "./auth/authActions";
import { queueActions } from "./queue/queueActions";
import { classesActions } from "./classes/classesActions";
import { registrationActions } from "./registration/registrationActions";
import { financialActions } from "./financial/financialActions";

export const rootActions = {
    auth: authActions,
    queue: queueActions,
    classes: classesActions,
    registration: registrationActions,
    financial: financialActions,
};
